import { Text, TextProps } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function SectionText(props: TextProps) {
  return <Text color="chakra-subtle-text" my={2} {...props} />;
});
